// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ok-button {
    width: 100%;
    margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/modals/block-email-confirm-modal/block-email-confirm-modal.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".ok-button {\r\n    width: 100%;\r\n    margin-bottom: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
